import React from "react"
import styles from "./styles.module.css"
import classnames from "classnames"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import iconsMap from "../../utils/iconMap"
import SharedComponents from "../SharedComponents"

import { Row, Column } from "styled-grid-system-component"

const StyledContainer = styled.div`
  max-width: 900px;
  margin: auto;
  position: relative;
`

const HeaderWrapper = styled.header`
  height: 250px;
  background-color: rgb(0, 0, 0);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  position: relative;
  @media (max-width: 992px) {
    height: 405px;
  }
  @media (max-width: 576px) {
    height: 782px;
  }
`

const Summary = styled.div`
  margin-top: 25px;
  color: #fff;
  max-width: 470px;
`

const PhotoContainer = styled.div`
  width: 250px;
  height: 350px;
  position: absolute;
  top: 25px;
  left: 25px;
  z-index: 1;

  &:before {
    content: " ";
    position: absolute;
    top: ${SharedComponents.BorderOffset};
    left: ${SharedComponents.BorderOffset};
    right: ${SharedComponents.BorderOffset};
    bottom: ${SharedComponents.BorderOffset};
    z-index: -1;
    background: linear-gradient(125deg, #89ff00, #010615, #ff005e);
    filter: blur(20px);
  }

  &:after {
    content: " ";
    position: absolute;
    top: ${SharedComponents.BorderOffset};
    left: ${SharedComponents.BorderOffset};
    right: ${SharedComponents.BorderOffset};
    bottom: ${SharedComponents.BorderOffset};
    z-index: -1;
    background: #fff;
    border-top-left-radius: ${SharedComponents.BorderRadius};
    border-bottom-right-radius: ${SharedComponents.BorderRadius};
  }

  @media (max-width: 768px) {
    width: 225px;
    height: 315px;
  }

  @media (max-width: 576px) {
    position: relative;
    top: auto;
    left: auto;
    margin: 25px auto 0;
  }
`

const MainHeader = styled.h1`
  text-transform: uppercase;
  font-family: Exo;
  font-weight: 700;
  margin-bottom: 25px;
  margin-left: 1%;
  font-size: 24px;
  @media (max-width: 576px) {
    text-align: center;
  }
`

const JobTitle = styled.h3`
  margin-bottom: 20px;
  margin-left: 1%;
  font-size: 19px;
  @media (max-width: 576px) {
    text-align: center;
  }
`

const ContactsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const StyledImage = styled(Img)`
  border-top-left-radius: ${SharedComponents.BorderRadius};
  border-bottom-right-radius: ${SharedComponents.BorderRadius};
`

const ContactsLink = ({ contacts_style, link, target, style, children }) => (
  <a
    href={link}
    className={classnames(contacts_style, styles[`contact_${style}`])}
    target={target ? "_blank" : "_self"}
    without
    rel="noreferrer"
  >
    {children}
  </a>
)

const LinkIcon = ({ fa, style }) => (
  <i className={classnames(fa, style, iconsMap[fa])} aria-hidden="true"></i>
)

const Header = ({ avatar }) => {
  const {
    site,
    siteContacts: { contacts },
  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            fio
            author
            jobTitle
          }
        }
        siteContacts: dataJson {
          contacts {
            class
            fa
            link
            target
            text
          }
        }
      }
    `
  )

  return (
    <HeaderWrapper className={styles.header}>
      <StyledContainer>
        <Row>
          <PhotoContainer>
            <StyledImage fluid={avatar} />
          </PhotoContainer>
          <Column
            xl={7}
            xlOffset={4}
            lg={8}
            lgOffset={4}
            md={7}
            mdOffset={5}
            sm={6}
            smOffset={6}
            xs={12}
          >
            <Summary>
              <MainHeader className={styles.main_header}>
                {site.siteMetadata.fio}
              </MainHeader>
              <JobTitle className={styles.secondary_header}>
                {site.siteMetadata.jobTitle}
              </JobTitle>

              <ContactsContainer className={styles.contacts}>
                {contacts.map((c, idx) => (
                  <ContactsLink
                    contacts_style={styles.contacts_link}
                    style={c.class}
                    link={c.link}
                    target={c.target}
                    key={`contact_${idx}`}
                  >
                    <LinkIcon fa={c.fa} style={styles.contacts_link_icon} />
                    {c.text}
                  </ContactsLink>
                ))}
              </ContactsContainer>
            </Summary>
          </Column>
        </Row>
      </StyledContainer>
    </HeaderWrapper>
  )
}

export default Header
